// extracted by mini-css-extract-plugin
module.exports = {"givePriority":"styles_givePriority__2teG9","comparisonSelect":"styles_comparisonSelect__38aHb"};